/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-05-17 14:20:55
 * description  : 描述
 * author       : zhizhan
 */
import "./index.less";
import React from "react";
import { Drawer } from "antd";
import defaultProps from "./param";
import YxAction from "../../YxAction";
import { get, merge } from "../../../utils/index";
import { YxComponent, Connection } from "../../YxComponent";

@Connection(defaultProps)
export default class extends YxComponent {
  constructor(...args) {
    super(...args);
    this.state = {};
    this.className = "yx_drawer";
  }

  actionJsx = () => {
    const okText = get(this.props, "okText", null);
    if (okText != null) {
      const param = {
        text: okText,
        type: "primary",
        actionType: "action",
        onClick: () => get(this.props, "onOk", () => {})(),
      };
      return <YxAction {...param} />;
    } else {
      return null;
    }
  };

  get children() {
    const DOM = (
      <div>
        {this.props.children}
        {this.actionJsx()}
      </div>
    );
    return DOM;
  }

  render() {
    let tmpProps = this.props;
    const propsClassName = get(this.props, "className", "");
    const className = [this.className, propsClassName];
    return (
      <Drawer
        destroyOnClose={true}
        {...tmpProps}
        className={className.join(" ")}
      >
        {this.children}
      </Drawer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxModal/Drawer/index.js